import Base from './base'
import Request from '@utils/request'
import { toQueryString, newFormData } from '@utils'

class Feedback extends Base {
  async show (id, params = {}) {
    const url = `/api/feedback/${id}?${toQueryString(params)}`
    const response = await Request.get(url)

    return response
  }

  async store (payload) {
    const data = newFormData(payload)

    const response = await Request.custom({
      url: '/api/feedback',
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    })

    return response
  }

  async delete (id) {
    const response = await Request.delete(`/api/admin/feedback/${id}`)

    return response
  }
}

export default new Feedback()
